import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import styled from 'styled-components';
import { useThemeContext } from '../../styles/themes/themes.js';
import { format } from '../../utils/strings.js';
import { checkboxComponents, Checkbox } from '../Checkbox/Checkbox.js';
import { IconFavoriteSelected } from '../Icons/IconFavoriteSelected.js';
import { IconFavoriteUnselected } from '../Icons/IconFavoriteUnselected.js';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _excluded = ["disabled", "size", "onRating", "rating", "legend"];
var gapSize = {
  16: 5,
  20: 5,
  24: 8,
  32: 10
};
var RatingsContainer = styled.div.withConfig({
  displayName: "Ratings__RatingsContainer",
  componentId: "ystkw0-0"
})(["&&{color:", ";cursor:", ";display:flex;position:relative;}&& ", "{position:relative;display:inherit;margin-right:", "px;}&& ", ":last-of-type{margin-right:0;}"], function (p) {
  return p.theme.neutralColors.smoke;
}, function (p) {
  return !p.$disabled && "pointer";
}, checkboxComponents.CheckboxWrapper, function (p) {
  return gapSize[p.$size];
}, checkboxComponents.CheckboxWrapper);
var Ratings = /*#__PURE__*/React.forwardRef(function Component(props, ref) {
  var _useThemeContext = useThemeContext(),
      i18n = _useThemeContext.i18n;

  var disabled = props.disabled,
      _props$size = props.size,
      size = _props$size === void 0 ? 16 : _props$size,
      onRating = props.onRating,
      _props$rating = props.rating,
      rating = _props$rating === void 0 ? 0 : _props$rating,
      _props$legend = props.legend,
      legend = _props$legend === void 0 ? i18n.Ratings.defaultLegend : _props$legend,
      rest = _objectWithoutProperties(props, _excluded);

  var _React$useState = React.useState(Math.round(rating)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentRating = _React$useState2[0],
      setCurrentRating = _React$useState2[1];

  var _React$useState3 = React.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      hoverIndex = _React$useState4[0],
      setHoverIndex = _React$useState4[1];

  var onFieldsetLeave = function onFieldsetLeave() {
    return setHoverIndex(0);
  };

  return /*#__PURE__*/jsx(RatingsContainer, _objectSpread(_objectSpread({
    ref: ref,
    $size: size,
    $disabled: disabled
  }, rest), {}, {
    children: /*#__PURE__*/jsxs("fieldset", {
      onBlur: onFieldsetLeave,
      onMouseLeave: onFieldsetLeave,
      children: [/*#__PURE__*/jsx(VisuallyHidden, {
        children: /*#__PURE__*/jsx("legend", {
          children: legend
        })
      }), [1, 2, 3, 4, 5].map(function (i) {
        var onCheckboxEnter = function onCheckboxEnter() {
          return setHoverIndex(i);
        };

        return /*#__PURE__*/jsx(Checkbox, {
          type: "radio",
          name: "ratings",
          onFocus: onCheckboxEnter,
          onMouseEnter: onCheckboxEnter,
          icon: IconFavoriteUnselected,
          iconChecked: IconFavoriteSelected,
          checked: Math.max(hoverIndex, currentRating) >= i,
          onChange: function onChange() {
            setCurrentRating(i);
            if (onRating) onRating(i);
          },
          disabled: props.disabled,
          "aria-label": format(i18n.Ratings.label, "".concat(i)),
          size: size
        }, i);
      })]
    })
  }));
});
Ratings.propTypes = {
  "disabled": _PropTypes.bool,
  "legend": _PropTypes.string,
  "onRating": _PropTypes.func,
  "rating": _PropTypes.number,
  "size": _PropTypes.oneOf([16, 20, 24, 32])
};
Ratings.displayName = "Ratings";

export { Ratings };
